import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-delete-dialog-action',
    template: `
    <section>
      <h4 mat-dialog-title>{{ (this.data.type === 'ACTION' ? 'ACTIONS.CONFIRM_DELETE': 'ACTIONS.KPI.CONFIRM_DELETE') | translate }}</h4>
      <mat-dialog-actions>
        <section class="d-flex justify-content-center" mat-dialog-actions>
            <button mat-flat-button mat-dialog-close>
            {{ 'CANCEL' | translate }}
            </button>

            <button
            [disabled]="!deleteForm.valid"
            mat-flat-button
            color="warn"
            [mat-dialog-close]="deleteForm.get('resourceToDelete')?.value"
            class="ms-3"
            >
            {{ 'CONFIRM' | translate }}
            </button>
        </section>
      </mat-dialog-actions>
    </section>
  `,
    imports: [MatDialogTitle, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class DeleteDialogActionComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  data = inject<{
    resource: any;
    resourceName: string;
    type: 'ACTION' | 'KPI';
}>(MAT_DIALOG_DATA);

  deleteForm!: UntypedFormGroup;

  ngOnInit(): void {
    this.deleteForm = this.fb.group({
      resourceToDelete: [this.data.resource],
    });
  }
}
